export default "__VITE_ASSET__8CJQd5Lj__"